import { useAnalyticsEvent, useAnalyticsPageVisit } from '@skin-seoul/service';
import { useCookieConsentStatus } from '../provider/ShortcodeCookieConsentProvider';

interface CampaignPageViewTrackerProps {
  campaignSlug?: string;
  goLiveInstant?: number;
  expireInstant?: number;
}

export function CampaignPageViewTracker({ campaignSlug, goLiveInstant, expireInstant }: CampaignPageViewTrackerProps) {
  const analytics = useAnalyticsEvent();
  const { hasAnalyticsConsent } = useCookieConsentStatus();
  const pathname = window.location.pathname;

  useAnalyticsPageVisit({
    pathname,
    enabled: hasAnalyticsConsent === true,
    canTrack: () => {
      if (campaignSlug === undefined) {
        return /^\/campaign\/?$/.test(pathname) || /^\/blog(?:\/|$)/.test(pathname);
      }
      const campaignPath = pathname.match(/^\/campaign\/([^/]+)\/?$/);
      if (!campaignPath || campaignPath[1] !== campaignSlug) {
        return false;
      }
      const now = Date.now();
      return (
        (goLiveInstant === undefined || (Number.isFinite(goLiveInstant) && now >= goLiveInstant)) &&
        (expireInstant === undefined || (Number.isFinite(expireInstant) && now < expireInstant))
      );
    },
    onView: (uniqueId) =>
      analytics.trackBrowsing({
        pageType: /^\/blog(?:\/|$)/.test(pathname) ? 'Blog' : 'Promotion',
        params: campaignSlug === undefined ? undefined : { campaign_slug: campaignSlug },
        services:
          campaignSlug === undefined || /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(campaignSlug)
            ? ['mixpanel', 'bigquery', 'paidmedia']
            : ['mixpanel', 'bigquery'],
        uniqueId,
      }),
  });

  return null;
}
